import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/E3_more.svg"

const E3more: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 74 74'} component={Icon} {...props} fill="currentColor" />
export default E3more
